export default __webpack_public_path__ + "navigation-examples-custom-waypoint-thumbnail-480-ede4372670ee9e0dc8b2e9f4f7033d80.webp";